import { Box, IconButton } from "@mui/material"
import { MoreVertOutlined } from "@mui-symbols-material/w300"
import type { Row } from "@tanstack/react-table"
import { type ReactElement, useRef, useState } from "react"

import ClassFormDialog from "../../dialogs/ClassFormDialog"
import type { EditDialogMode } from "../../types"

import type { Classification } from "@/graphql/codegen/graphql"
import ClassificationActionsDropdownMenu from "@/screens/ManageProducts/components/ProductClasses/components/table/ClassificationActionsDropdown"
import useSearchList from "@/screens/ManageProducts/components/ProductClasses/hooks/useSearchList"

interface ClassificationActionsProps {
  row: Row<Classification>
}

export const ClassificationActions = ({ row }: ClassificationActionsProps): ReactElement => {
  const [isMenuOpened, setIsMenuOpened] = useState<boolean>(false)
  const [editDialogMode, setEditDialogMode] = useState<EditDialogMode | null>(null)

  const classification = row.original
  const anchorElRef = useRef<HTMLButtonElement>(null)
  const { refetchData } = useSearchList()

  const handleOpen = () => {
    setIsMenuOpened(true)
  }
  const handleClose = () => {
    setIsMenuOpened(false)
  }

  const onSelectEditMode = (mode: EditDialogMode) => {
    setEditDialogMode(mode)
  }

  return (
    <Box className='flex items-center justify-end space-x-4' data-test='classification-actions'>
      <Box className='flex items-center justify-end' ref={anchorElRef}>
        <IconButton onClick={handleOpen}>
          <MoreVertOutlined />
        </IconButton>
        {isMenuOpened && (
          <ClassificationActionsDropdownMenu
            onSelectEditMode={onSelectEditMode}
            anchorEl={anchorElRef.current}
            onClose={handleClose}
          />
        )}
        {editDialogMode && (
          <ClassFormDialog
            mode={editDialogMode}
            data={classification}
            onClose={() => setEditDialogMode(null)}
            onSuccess={refetchData}
          />
        )}
      </Box>
    </Box>
  )
}
